import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { CreditCardDetailsEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import {
    ECheckDetailsEntryStyles,
} from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ECheckDetailsEntry";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { CheckboxProps } from "@insite/mobius/Checkbox";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { RadioComponentProps } from "@insite/mobius/Radio";
import { RadioGroupProps } from "@insite/mobius/RadioGroup";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextAreaProps } from "@insite/mobius/TextArea";
import { TextFieldPresentationProps } from "@insite/mobius/TextField/TextField";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import {
    CreditCardBillingAddressEntryStyles,
} from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardBillingAddressEntry";
import {
    PayPalButtonStyles,
} from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/PayPalButton";
import {
    SavedPaymentProfileEntryStyles,
} from "@MasterBluePrint/Overrides/Widgets/CheckoutReviewAndSubmit/SavedPaymentProfileEntry";
import themeColors, { themeFontSizes, themeFontWeights } from "@MasterBluePrint/Styles/variables";
import { css } from "styled-components";

import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";


export interface CheckoutReviewAndSubmitPaymentDetailsStyles {
    form?: InjectableCss;
    fieldset?: InjectableCss;
    paymentDetailsHeading?: TypographyPresentationProps;
    paymentMethodPayPalText?: TypographyPresentationProps;
    paymentMethodAndPONumberContainer?: GridContainerProps;
    paymentMethodGridItem?: GridItemProps;
    paymentMethodSelect?: SelectPresentationProps;
    paymentProfileBillingAddress?: any;
    paymentProfileExpiredErrorWrapper?: InjectableCss;
    paymentProfileExpiredErrorText?: TypographyPresentationProps;
    paymentProfileEditCardLink?: LinkPresentationProps;
    vatNumberGridItem?: GridItemProps;
    vatNumberText?: TextFieldPresentationProps;
    poNumberGridItem?: GridItemProps;
    taxExemptGridItem?: GridItemProps;
    poNumberText?: TextFieldPresentationProps;
    taxCodeNumberText?: TextFieldPresentationProps;
    emptyGridItem?: GridItemProps;
    mainContainer?: GridContainerProps;
    savedPaymentProfile?: SavedPaymentProfileEntryStyles;
    creditCardDetailsGridItem?: GridItemProps;
    creditCardSelectedDetailsGridItem?: GridItemProps;
    eCheckDetailsGridItem?: GridItemProps;
    creditCardDetails?: CreditCardDetailsEntryStyles;
    creditCardAddressGridItem?: GridItemProps;
    creditCardAddress?: CreditCardBillingAddressEntryStyles;
    wirePaymentGridItem?: GridItemProps;
    wirePaymentGridcontainer?: GridContainerProps;
    wireTitleContainer?: InjectableCss;
    wirePaymentDetails?: GridItemProps;
    wirePaymentWarningMessage?: InjectableCss;
    wirePaymentInfoContainer?: GridContainerProps;
    wirePaymentInfoLeftPart?: GridItemProps;
    wirePaymentHeadingAndText?: InjectableCss;
    wirePaymentText?: SmallHeadingAndTextStyles;
    wirePaymentInfoRightPart?: GridItemProps;
    wireTaxDetails?: GridItemProps;
    wireAccountReceiveDetails?: GridItemProps;
    wireAccountReceivableContactDetails?: InjectableCss;
    accountReceivableContactContainer?: GridContainerProps;
    accountReceivablePhone?: GridItemProps;
    accountReceivableEmail?: GridItemProps;
    accountReceivableOther?: GridItemProps;

    payPalButton?: PayPalButtonStyles;
    eCheckDetailsEntryStyles?: ECheckDetailsEntryStyles;
    collectGridItem?: GridItemProps;
    taxExemptHeaderText?: TypographyProps;
    taxExemptRadioGroup?: RadioGroupProps;
    taxExemptYesRadio?: RadioComponentProps;
    taxExemptNoRadio?: RadioComponentProps;
    taxExemptText?: InjectableCss;
    taxExemptmsgContainer?: InjectableCss;
    spacingAdjust?: InjectableCss;
    paymentContainer?: InjectableCss;
    textArea?: TextAreaProps;
    tooltip?: InjectableCss;
    tooltipHeading?: InjectableCss;
    tooltipContent?: InjectableCss;
    tooltipIcon?: InjectableCss;
    rememberMeCheckbox?: CheckboxProps;
    checkBoxProps?: IconPresentationProps;

    cardBookModalButtonsWrapper?: InjectableCss;
    cardBookModalCancelButton?: InjectableCss;
    wideCreateNewAddressButton?: InjectableCss;
    selectSavedCardButton?: InjectableCss;
    buttonWrapper?: InjectableCss;
    closeContainer?: InjectableCss;
    customBillingBookModal?: InjectableCss;
    selectCard?: InjectableCss;
    titleContainer?: InjectableCss;
    paymentMethodsErrorDesktop?: InjectableCss;
    addressBookModalContinueButton?: ButtonPresentationProps;
    spinner?: LoadingSpinnerProps;
    centeringWrapper?: InjectableCss;

}
export const checkoutReviewAndSubmitPaymentDetailsStyles: CheckoutReviewAndSubmitPaymentDetailsStyles = {
    paymentMethodsErrorDesktop: {
        css: css`
        font-size: ${themeFontSizes.size14};
        font-style: italic;
        letter-spacing: 0.16px;
        color: ${themeColors.colorDanger};
        font-weight: ${themeFontWeights.fontWeightRegular};
        padding: 0.625rem 0 0;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
            color: #002554;
        `,
    },
    centeringWrapper: {
        css: css`
            background: rgba(0, 37, 84, 0.2);
            height: 100%;
            width: 100%;
            position: fixed;
            z-index: 99;
            left: 0;
            top: 0;
            display: flex;
            align-items: center;
        `,
    },
    fieldset: {
        css: css`
            margin: 0 0 1.875rem 0;
            padding: 0;
            border: 0;
            > iframe > html > body > input,
            > iframe #data {
                width: 100%;
                box-sizing: border-box;
                appearance: none;
                height: 2.5rem;
                font-family: 'Lato',sans-serif;
                font-size: 0.875rem;
                padding: 0 0.625rem;
                color: rgb(126, 145, 168) !important;
                border: 0.0625rem solid rgb(194, 211, 234) !important;
                border-radius: 0.125rem !important;
                background-color: rgb(247, 249, 255) !important;
            }
        `,
    },
    paymentDetailsHeading: {
        variant: "h5",
        css: css`
            &.section-heading {
                color: ${themeColors.colorPrimary};
                font-family: 'Roboto', sans-serif;
                font-size: ${themeFontSizes.size20};
                font-weight: ${themeFontWeights.fontWeightForBold};
                letter-spacing: 0;
                line-height: 1.375rem;
                margin-bottom: 1.25rem;

                &:before {
                    display: inline-block;
                    border: 0.0625rem solid ${themeColors.colorPrimary};
                    border-radius: 100%;
                    content: attr(data-number);
                    height: 1.5625rem;
                    width: 1.5625rem;
                    background-color: ${themeColors.colorPrimary};
                    color: ${themeColors.colorWhite};
                    font-family: 'Roboto', sans-serif;
                    font-size: ${themeFontSizes.size16};
                    font-weight: ${themeFontWeights.fontWeightForBold};
                    letter-spacing: 0;
                    line-height: 1.5rem;
                    margin-right: .9375rem;
                    text-align: center;
                    vertical-align: middle;
                }
            }
        `,
    },
    paymentMethodAndPONumberContainer: {
        gap: 10,
        css: css`
            margin-bottom: 1rem;
        `,
    },
    paymentMethodGridItem: {
        width: 12,
        css: css`
            flex-direction: column;

            div[data-test-selector="payPalButton"] {
                display: inline-block;
                padding-top: 0;
                vertical-align: middle;
            }

            .payment-method-desktop {
                width: auto;
                margin: 0 auto .9375rem;
            }

            .payment-method-mobile {
                width: 100%;
                margin: 0 auto .9375rem;

                select[data-test-selector="checkoutReviewAndSubmit_paymentMethod"] {
                    background-color: ${themeColors.colorHeadText} !important;
                    color: ${themeColors.colorWhite} !important;
                }

                svg {
                    color: ${themeColors.colorWhite} !important;
                }
            }

            .button-container {
                text-align: center;
                border: 0.0625rem solid ${themeColors.colorBorderCyanBlue};
                border-radius: 0.125rem;
                background-color: ${themeColors.colorBorderCyanBlueNew};
                margin: 0 auto;
                position: relative;
                padding: 0.3125rem;

                &.payment-error {
                    border: 0.0625rem solid ${themeColors.colorDanger};
                }
            }

            .select-pay-button {
                color: ${themeColors.colorPrimary} !important;
                font-family: 'Roboto', sans-serif;
                font-size: ${themeFontSizes.size16};
                font-weight: ${themeFontWeights.fontWeightMedium};
                letter-spacing: 0;
                line-height: 1.1875rem;
                text-align: center;
                padding: .875rem 3.125rem;
                display: inline-block;
                background: none !important;
                border: none !important;
                max-width: 18.250625rem;
                min-width: 11.875rem;
                cursor: pointer;
                position: relative;

                &.current {
                    color: ${themeColors.colorWhite} !important;
                    background-color: ${themeColors.colorHeadText} !important;

                    svg {
                        color: ${themeColors.colorWhite};
                        fill: ${themeColors.colorWhite};

                        g {
                            fill: ${themeColors.colorWhite};
                        }
                    }

                    + span {
                        svg {
                            color: ${themeColors.colorWhite};
                            fill: ${themeColors.colorWhite};

                            g {
                                fill: ${themeColors.colorWhite};
                            }
                        }
                    }
                }
            }
            @media (max-width: 1200px) {
                .payment-method-desktop {
                    width: auto;
                }
                .select-pay-button {
                    min-width: 150px;
                }
            }
            @media (max-width: 102.250625rem) {
                .payment-method-desktop {
                    width: auto;
                }
                .select-pay-button {
                    min-width: 8.125rem;
                }
            }
            @media (max-width: 990px) {
                .select-pay-button {
                    min-width: 0.625rem;
                }
            }
        `,
    },
    paymentProfileExpiredErrorWrapper: {
        css: css`
            display: flex;
            width: 100%;
        `,
    },
    paymentProfileExpiredErrorText: { color: "danger" },
    paymentProfileEditCardLink: {
        css: css`
            margin-left: 1rem;
        `,
    },
    vatNumberGridItem: { width: 6 },
    poNumberGridItem: {
        width: 6,
        css: css`
            padding-left: .9375rem;

            .po-container {
                background-color: ${themeColors.colorBackgroundLightGrey};
                padding: 2.1875rem 1.5625rem 2.8125rem 1.5625rem;
                width: 100%;
            }

            div[class^="FormFieldStyle"],
            div[class*=" FormFieldStyle"] {
                div[class^="FormInputWrapper"],
                div[class*=" FormInputWrapper"] {
                    margin-top: 0.3125rem;
                }
            }

            input:not(.react-datetime-picker__inputGroup__input).po-text-field {
                background-color: ${themeColors.colorWhite} !important;
            }

            .optional {
                color: ${themeColors.colorMidGrey};
                font-family: 'Roboto',sans-serif;
                font-size: ${themeFontSizes.size14};
                font-style: italic;
                letter-spacing: 0.16px;
                line-height: 1.4375rem;
                font-weight: ${themeFontWeights.fontWeightRegular};
            }

            label[class^="TypographyStyle"],label[class*="TypographyStyle"] {
                font-size: ${themeFontSizes.size14};
                font-weight: ${themeFontWeights.fontWeightMedium};
                font-family: 'Roboto',sans-serif;
                span > span {
                    padding-left: .9375rem;                        
                }
            }

            @media screen and (max-width: 990px) {
                padding-left: 0;
                order: 5;
                flex-basis: 100%;
                max-width: 100%;

                .po-container {
                    padding: 1.25rem 0.9375rem 1.25rem .9375rem;
                }
            }
        `,
    },
    emptyGridItem: {
        width: 6,
        css: css`
            &:empty {
                display: none;
            }
        `,
    },
    creditCardDetailsGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            // .cc-address-heading,
            // .use-bill-address {
            //     display: none;
            // }
        `,
    },
    creditCardSelectedDetailsGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    eCheckDetailsGridItem: { width: [12, 12, 12, 6, 6] },
    creditCardAddressGridItem: {
        width: 12,
        css: css`
            // .cc-address-heading,
            // .use-bill-address {
            //     display: none;
            // }
        `,
    },
    wirePaymentGridItem: {
        width: 12,
        css: css`
            .wire-heading {
                color: ${themeColors.colorHeadText};
                font-family: 'Roboto', sans-serif;
                font-size: ${themeFontSizes.size18};
                font-weight: ${themeFontWeights.fontWeightMedium};
                letter-spacing: 0;
                line-height: 1.375rem;
                margin-bottom: .9375rem;
                margin-top: 0.3125rem;
            }
        `,

    },
    wirePaymentGridcontainer: {
        gap: 10
    },
    wireTitleContainer: {
        css: css`
            width: 100%;
            display: block;
        `,
    },
    wirePaymentDetails: {
        width: 12,
        css: css`
            padding: 10px 0;
            border-top: 1px solid #C2D1D9;
            border-bottom: 1px solid #C2D1D9;
            flex-direction: column;
        `,
    },
    wirePaymentWarningMessage: {
        css: css`
            width: 100%;
            border: 1px solid #FFDEB2;
            border-radius: 2px;
            background-color: #FFEFD9;
            padding: 10px;

            > span {
                color: #2E384D;
                font-family: Lato;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 24px;
            }
        `,
    },
    wirePaymentInfoContainer: {
        css: css`
            padding: 20px 0 10px;
        `,
    },
    wirePaymentInfoLeftPart: {
        width: [12, 12, 12, 7, 7],
        css: css`
            .wire-payment-info {
                width: 100%;

                p[data-test-selector="heading"] {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 30px;
                    letter-spacing: 0;
                    color: #002554;
                    font-family: 'Roboto',sans-serif;
                    text-transform: capitalize;
                }
                p[data-test-selector="text"] {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 30px;
                    letter-spacing: 0.18px;
                    color: #2E384D;
                    font-family: 'Lato',sans-serif;
                }
                .wirepayment-bank-info-address {
                    display: block;
                    p[data-test-selector="text"] {
                        width: 200px;
                    }
                }
                .wirepayment-bank-info-phone {
                    display: block;
                    border-bottom: 1px solid #C2D1D9;
                }
                .wirepayment-bank-info-contact {
                    padding: 10px 20px 20px 30px;
                    display: block;

                    div:first-child {
                        p[data-test-selector="text"] {
                            color: #002554;
                            font-family: 'Lato',sans-serif;
                            font-size: 18px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 22px;
                        }
                    }

                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                padding: 0;
                            `,
                    ],
                    "max",
                )}
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                        padding-bottom: 0;
                    `,
                    ],
                    "max",
                )}
        `,
    },
    wirePaymentHeadingAndText: {
        css: css`
            margin-bottom: 15px;
        `,
    },
    wirePaymentInfoRightPart: {
        width: [12, 12, 12, 5, 5],
        css: css`
            .wirepayment-bank-account-details {
                width: 100%;
                display: block;
                box-sizing: border-box;
                border: 1px solid #C3D4EA;
                border-radius: 2px;
                background: #F7F9FA;
                padding: 20px;

                p[data-test-selector="heading"] {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 30px;
                    letter-spacing: 0;
                    color: #002554;
                    font-family: 'Roboto',sans-serif;
                    text-transform: capitalize;
                }
                p[data-test-selector="text"] {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 30px;
                    letter-spacing: 0.18px;
                    color: #2E384D;
                    font-family: 'Lato',sans-serif;
                }
                .wirepayment-account-info,
                .wire-account-information,
                .wire-account-info {
                    p[data-test-selector="text"] { 
                        font-size: 18px;
                        letter-spacing: 0.21px;
                    }
                }
            }
        `,
    },
    wireTaxDetails: {
        width: 12,
        css: css`
            font-size: 18px;
            letter-spacing: 0;
            border-bottom: 1px solid #C2D1D9;
            padding: 10px 0;
            align-items: center;
            
            .wire-tax-label {
                color: #2060AD;
                font-family: 'Roboto',sans-serif;                
                font-weight: 500;                
                line-height: 23px;
            }
            .wire-tax-value {
                color: #333F48;
                font-family: 'Lato',sans-serif;
                font-weight: bold;
                line-height: 30px;
                padding-left: 20px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                        align-items: flex-start;
                        flex-direction: column;

                        .wire-tax-value {
                            padding-left: 0;
                        }
                    `,
                    ],
                    "max",
                )}
        `,
    },
    wireAccountReceiveDetails: {
        width: 12,
        css: css`
        padding: 0;
            flex-direction: column;

            div[data-test-selector="accountReceiveHeading"] {
                border-bottom: 1px solid #C2D1D9;
                padding: 15px 0 12px;

                .wire-heading {
                    margin: 0;
                }
            }
            span[data-test-selector="wirePaymentReceivableMsg"] {
                margin: 10px 0;
            }
        `,
    },
    wireAccountReceivableContactDetails: {
        css: css`
            width: 100%;
            display: block;
            border: 1px solid #C3D4EA;
            border-radius: 2px;
            background: #F7F9FA;
            padding: 20px;

            .receivable-name {
                padding-bottom: 10px;
                display: block;
                color: #002554;
                font-family: 'Lato',sans-serif;
                font-size: 18px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 22px;
            }
        `,
    },
    accountReceivableContactContainer: {
        gap: 10,
        css: css`
            p[data-test-selector="heading"] {
                color: #002554;
                font-family: 'Roboto',sans-serif;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 30px;
                text-transform: capitalize;
            }
            p[data-test-selector="text"] {
                color: #2E384D;
                font-family: 'Lato',sans-serif;
                font-size: 16px;
                letter-spacing: 0.18px;
                line-height: 30px;
            }

            .account-receivable-phone {
                p[data-test-selector="text"] {
                    font-size: 18px;
                    letter-spacing: 0.21px;
                }
            }

            .account-receivable-phone,
            .account-receivable-email,
            .account-receivable-other {
                div:first-child {
                    margin-bottom: 0;

                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                margin-bottom: 5px;
                            `,
                    ],
                    "max",
                )}
                }
            }
        `,
    },
    accountReceivablePhone: {
        width: [12, 12, 12, 4, 4],
        css: css`
            p[data-test-selector="text"] {
                font-size: 18px;
                letter-spacing: 0.21px;
            }
        `,
    },
    accountReceivableEmail: {
        width: [12, 12, 12, 4, 4],
        css: css`
            
        `,
    },
    accountReceivableOther: {
        width: [12, 12, 12, 4, 4],
        css: css`
            
        `,
    },
    collectGridItem: {
        width: [12],
    },
    taxExemptText: {
        css: css`
            display: flex;
            width: 100%;
            margin: 0.625rem 0;
            color: ${themeColors.colorAddress};
            font-family: 'Lato',sans-serif;
            font-size: ${themeFontSizes.size16};
            letter-spacing: 0.5px;
            line-height: 1.375rem;

            &:empty {
                display: none;
            }
        `,
    },
    taxExemptGridItem: {
        width: 12,
        css: css`
            flex-direction: row;
            margin-bottom: .9375rem;
            padding-bottom: 0;
            
            label {
                color: ${themeColors.colorAddress};
                font-family: 'Lato',sans-serif;
                font-size: ${themeFontSizes.size16};
                letter-spacing: 0;
                font-weight: ${themeFontWeights.fontWeightRegular};
            }

            h2.section-heading {
                margin-right: 1.875rem;

                &:before {
                    display: inline-block;
                    border: 0.0625rem solid ${themeColors.colorPrimary};
                    border-radius: 100%;
                    content: attr(data-number);
                    height: 1.5625rem;
                    width: 1.5625rem;
                    background-color: ${themeColors.colorPrimary};
                    color: ${themeColors.colorWhite};
                    font-family: 'Roboto', sans-serif;
                    font-size: ${themeFontSizes.size16};
                    font-weight: ${themeFontWeights.fontWeightForBold};
                    letter-spacing: 0;
                    line-height: 1.5rem;
                    margin-right: .9375rem;
                    text-align: center;
                    vertical-align: middle;
                }
            }

            > div {
                flex-direction: row;
            }

            @media screen and (max-width: 990px) {
                flex-direction: column;

                h2.section-heading,
                h3.section-heading {
                    + div {
                        margin-bottom: 1.125rem;
                    }
                }
            }
        `,
    },
    taxExemptmsgContainer: {
        css: css`
            width: 100%;
            max-width: 100%;
            flex-basis: 100%;
            padding: 1.875rem 2.8125rem;
            background: ${themeColors.colorWhite};
            box-shadow: 0 0.125rem .250625rem .250625rem rgba(0, 0, 0, 0.03);
            border-radius: 0.125rem;
            flex-direction: column;

            @media screen and (max-width: 990px) {
                padding: 1.875rem .9375rem;
            }

            &.tax-msg-container {
                margin-bottom: 0 !important;
                margin-left: 0.9375rem !important;
                margin-right: 0.9375rem !important;
                label {
                    color: ${themeColors.colorPrimary};
                    font-family: 'Roboto',sans-serif;
                    font-size: ${themeFontSizes.size14};
                    font-weight: ${themeFontWeights.fontWeightMedium};
                    letter-spacing: 0.16px;
                    line-height: 1.4375rem;
                }
                @media screen and (min-width: 768px) {
                    span {
                        max-width: 70%;
                    }
                }
            }

            &.tax-input-container {
                margin-bottom: 0 !important;
                margin-left: 0.9375rem !important;
                margin-right: 0.9375rem !important;

                label {
                    color: ${themeColors.colorPrimary};
                    font-family: 'Roboto', sans-serif;
                    font-size: ${themeFontSizes.size14};
                    font-weight: ${themeFontWeights.fontWeightMedium};
                    letter-spacing: 0.16px;
                    line-height: 1.4375rem;
                }

                input {
                    max-width: 24.250625rem;
                    border: 0.0625rem solid ${themeColors.colorBorderCyanBlue};
                    border-radius: 0.125rem;
                    background-color: ${themeColors.colorBorderCyanBlueNew};
                }
            }
        `,
    },
    paymentContainer: {
        css: css`
            padding: 1.875rem 2.8125rem;
            background: ${themeColors.colorWhite};
            box-shadow: 0 0.125rem .250625rem .250625rem rgba(0, 0, 0, 0.03);
            border-radius: 0.125rem;

            @media screen and (max-width: 990px) {
                padding: 1.875rem .9375rem;
            }
            
        `,
    },
    spacingAdjust: {
        css: css`
            margin-bottom: 2.8125rem !important;
        `,
    },
    taxCodeNumberText: {
        css: css`
            width: 15.3125rem;
            max-width: 15.3125rem;
        `,
    },
    textArea: {
        css: css`
            min-width: 100%;
            max-width: 100%;
            min-height: 3.125rem;
        `,
    },
    poNumberText: {
        css: css`
            &.po-text-field {
                background-color: ${themeColors.colorWhite};
            }
        `,
    },
    tooltipIcon: {
        css: css`
            display: inline-block;
            position: absolute;
            margin-left: 0.5rem;
            width: 1.375rem;
            height: 1.25rem;
            z-index: 2;
            cursor: pointer;
            top: 0.8125rem;
            left: 62%;
            @media (max-width: 1200px) {
                left: 62%;
            }

            span {
                width: 1.375rem;
            }

            svg {
                width: 1.5rem;
                height: 1.5rem;
                scale: 0.7;
            }
        `,
    },
    tooltip: {
        css: css`
            background-color: ${themeColors.colorWhite};
            box-shadow: 0 0.4375rem 1.0625rem 0 rgba(0, 37, 84, 0.23);
            position: absolute;
            width: 15.625rem;
            padding: 1.5625rem;
            right: auto;
            left: -5.3125rem;
            bottom: 2.8rem;
            display: none;
            z-index: 2;

            @media (max-width: 1300px) and (min-width: 1200px) {
                left: -5.3125rem;
            }

            @media (max-width: 1200px) and (min-width: 1100px) {
                left: -5.3125rem;
            }

            &.active {
                display: block;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            right: -6.625rem;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    tooltipHeading: {
        css: css`
            position: relative;
            color: ${themeColors.colorPrimary};
            font-family: 'Roboto', sans-serif;
            font-size: 1.125rem;
            font-weight: ${themeFontWeights.fontWeightMedium};
            letter-spacing: 0;
            line-height: 1.9375rem;
            margin-bottom: 1.25rem;
            text-align: left;
            &:after {
                height: 0.1875rem;
                width: 0.665rem;
                background-color: ${themeColors.colorDanger};
                content: "";
                display: inline-block;
                position: absolute;
                bottom: -0.125rem;
                left: 0.0625rem;
            }
        `,
    },
    tooltipContent: {
        css: css`
            color: ${themeColors.colorMeasureText};
            font-family: 'Lato',sans-serif;
            font-size: 0.9375rem;
            letter-spacing: 0.0106rem;
            line-height: 1.5rem;
            text-align: left !important;

            &:after {
                content: "";
                display: block;
                height: 0;
                position: absolute;
                width: 0;
                border: 0.75rem solid;
                border-color: ${themeColors.colorWhite} transparent transparent transparent;
                z-index: 99;
                bottom: -1.4375rem;
                right: 2.8125rem;
            }

            @media screen and (min-width: 1023px) and (max-width: 1100px) {
                &:after {
                    right: 5rem !important;
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            &:after {
                                right: 5rem !important;
                            }
                        `,
                        css`
                            &:after {
                                right: 6.25rem;
                            }
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },

    customBillingBookModal: {
        css: css`
            div[class^='ModalContent'], div[class*=' ModalContent']{
                position: relative;
                padding-bottom: 7.375rem;
                height: calc(100vh - 6.25rem);

                @media screen and (max-width: 767px) {
                    padding-bottom: 7.375rem;
                    height: calc(100vh - 3.125rem);
                }
            }

            iframe {
                width: 99.4%;
            }
                
            .border-seperator {
                border-bottom: 0.0625rem solid ${themeColors.colorBorderBrands};
                padding-top: 0;
                margin-top: 1.25rem;
                margin-bottom: 1.25rem;
                width: 100%;
                display: block;
            }

            > div {
                border: 0.0625rem solid rgba(7, 15, 44, 0.08);
                border-radius: 0.0625rem;
                background-color: ${themeColors.colorWhite};
                max-width: 35.625rem;
                margin-right: 0;
                margin-left: auto;
                margin-top: 0;
                max-height: 100vh;

                .border-seperator {
                    border-bottom: 0.0625rem solid ${themeColors.colorBorderBrands};
                    padding-top: 0;
                    margin-top: 1.25rem;
                    margin-bottom: 1.25rem;
                    width: 100%;
                    display: block;
                }

                @media (max-width: 767px) {
                    max-width: 100%;
                    margin-right: 0;
                    margin-left: 0;
                }

                .modal-title {
                    border-bottom: none;
                    padding-bottom: 0;

                    h2 {
                        display: none;

                        &.current {
                            display: block;
                            color: ${themeColors.colorPrimary};
                            font-family: 'Roboto', sans-serif;
                            font-size: ${themeFontSizes.size18};
                            font-weight: ${themeFontWeights.fontWeightMedium};
                            letter-spacing: 0;
                            line-height: 1.9375rem;
                            padding-top: 2.8125rem;
                            position: relative;
                            margin-bottom: 2.1875rem;
    
                            &:after {
                                height: 0.125rem;
                                width: 4.250625rem;
                                background-color: ${themeColors.colorDanger};
                                content: "";
                                display: inline-block;
                                position: absolute;
                                bottom: -0.1875rem;
                                left: 0.0625rem;
                            }
                        }
                        
                    }

                    button[aria-labelledby="close-modal"] {
                        display: none;
                    }
                }

                #modalTitle {
                    border-bottom: none;
                    padding-bottom: 0;
                    display: none;
                    h4 {
                        color: ${themeColors.colorPrimary};
                        font-family: 'Roboto', sans-serif;
                        font-size: ${themeFontSizes.size18};
                        font-weight: ${themeFontWeights.fontWeightMedium};
                        letter-spacing: 0;
                        line-height: 1.9375rem;
                        padding-top: 2.8125rem;
                        position: relative;

                        &:after {
                            height: 0.125rem;
                            width: 4.250625rem;
                            background-color: ${themeColors.colorDanger};
                            content: "";
                            display: inline-block;
                            position: absolute;
                            bottom: -0.1875rem;
                            left: 0.0625rem;
                        }
                    }

                    button[aria-labelledby="close-modal"] {
                        display: none;
                    }
                }
            }
            .toggle-content {
                display: none;

                &.active {
                    display: block;
                }
            }
        `,
    },
    addressBookModalContinueButton: {
        variant: "primary",
        css: css`
            background-color: ${themeColors.colorPrimary};
            border-color: ${themeColors.colorPrimary};
            color: ${themeColors.colorWhite};
            text-transform: uppercase;
            padding: 0 3.125rem;
            width: auto;
            border-radius: 0.125rem;

            @media screen and (max-width: 767px) {
                padding: 0 1.875rem;
            }

            &:hover,
            &:active, 
            &:focus {
                background-color: ${themeColors.colorPrimary} !important;
                border-color: ${themeColors.colorPrimary} !important;
                color: ${themeColors.colorWhite};
            }
        `,
    },
    cardBookModalButtonsWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-top: 4rem;
            margin-bottom: 4rem;
            justify-content: center;
            align-items: center;
            &.select-card-btn {
                margin-top: 0;
                margin-bottom: 0;

                .btn-wrapper {
                    border-radius: 0.0625rem;
                    box-shadow: 0 -0.125rem 0.375rem 0 rgba(0,0,0,0.31);
                    background-color: ${themeColors.colorWhite};
                    margin-top: 1.875rem;
                    padding-bottom: 1.875rem;
                    padding-top: 1.875rem;
                    position: fixed;
                    width: 35.625rem;
                    left: auto;
                    bottom: 0;
                    right: 0;

                    > div:last-child {
                        flex-direction: row;
                        max-width: 70%;
                        margin: 0 auto;
                        display: flex;
                        justify-content: end;
                    }

                    @media screen and (max-width: 767px) {
                        width: 100%;
                        box-shadow: none;
                        margin-top: 0.5rem;

                        > div:last-child {
                            flex-direction: row;
                            max-width: 80%;
                            margin: 0 auto;
                        }

                        > button[data-test-selector="customerAddressForm_save"] {
                            margin-bottom: 0;
                        }
                    }
                }

                @media screen and (max-width: 767px) {
                    > button[data-test-selector="customerAddressForm_save"] {
                        margin-bottom: 0;
                    }
                }
            }
            
        `,
    },
    cardBookModalCancelButton: {
        css: css`
            color: ${themeColors.colorPrimary};
            font-family: 'Roboto', sans-serif;
            font-size: ${themeFontSizes.size15};
            letter-spacing: 0;
            line-height: 1.3125rem;
            text-align: center;
            text-decoration: underline;
            padding: 0;
            background: none;
            border: none;
            color: ${themeColors.colorGreyCancel};

            span {
                color: ${themeColors.colorGreyCancel};
                font-weight: ${themeFontWeights.fontWeightNormal};
            }

            &:hover,
            &:active,
            &:focus {
                background: none !important;
                border: none !important;
                color: ${themeColors.colorPrimary};

                span {
                    color: ${themeColors.colorPrimary};
                    font-weight: ${themeFontWeights.fontWeightNormal};
                }
            }

            &.cancel-btn {
                position: fixed;
                bottom: 1.8rem;
                left: auto;
                right: 25.625rem;
            }
            @media screen and (max-width: 767px) {
                &.cancel-btn {
                    right: auto;
                    left: 13%;
                }
            }
        `,
    },
    closeContainer: {
        css: css`
            position: absolute;
            left: 1.8rem;
            top: 1.5rem;
            cursor: pointer;
            z-index: 9;
            
            .close-label {
                color: ${themeColors.colorMidGrey};
                font-family: 'Roboto', sans-serif;
                font-size: 0.875rem;
                letter-spacing: 0;
                line-height: 1;
                display: inline-block;
                margin-right: 0.525rem;
                vertical-align: middle;
            }
            .icon-close {
                display: inline-block;
                cursor: pointer;
                vertical-align: middle;
                line-height: 1;
                width: 1rem;
                height: 1rem;
                svg {
                    height: 1rem;
                    width: 1rem;
                    color: ${themeColors.colorMidGrey};
                }
            }
            @media screen and (max-width: 990px) {
                right: 1.25rem;
            }
        `,
    },
    wideCreateNewAddressButton: {
        css: css`
            margin-left: 0;
            flex-basis: 50%;
            max-width: 50%;
            margin-bottom: 0;
            width: 50%;
            color: ${themeColors.colorPrimary} !important;
            font-family: 'Roboto', sans-serif;
            font-size: ${themeFontSizes.size14};
            font-weight: ${themeFontWeights.fontWeightMedium};
            letter-spacing: 0;
            line-height: 1.1875rem;
            text-align: center;
            padding: 0.625rem 0;
            display: inline-block;
            background: none !important;
            border: none !important;
            cursor: pointer;
            vertical-align: middle;
            span {
                font-size: ${themeFontSizes.size14};
                font-weight: ${themeFontWeights.fontWeightMedium};
            }
            &.current {
                color: ${themeColors.colorWhite} !important;
                background-color: ${themeColors.colorHeadText} !important;

                svg {
                    color: ${themeColors.colorWhite} !important;
                }
            }

            @media (max-width: 767px) {
                height: auto;
                text-align: left;
                padding-left: .9375rem;
                position: relative;

                .text {
                    max-width: 6.875rem;
                    display: inline-block;
                    vertical-align: bottom;
                    text-align: left;
                }

                .arrows {
                    display: inline-block;
                    vertical-align: bottom;
                    line-height: 1rem;
                    height: 1.125rem;
                    position: absolute;
                    right: .9375rem;
                    bottom: 0.625rem;
                }

                .up-arrow {
                    display: none;
                }

                &.current {
                    .down-arrow {
                        display: none;
                    }

                    .up-arrow {
                        display: inline-block;
                    }
                }
            }
        `,
    },
    selectSavedCardButton: {
        css: css`
            width: 50%;
            flex-basis: 50%;
            max-width: 50%;
            margin-bottom: 0;
            width: 50%;
            color: ${themeColors.colorPrimary} !important;
            font-family: 'Roboto', sans-serif;
            font-size: ${themeFontSizes.size14};
            font-weight: ${themeFontWeights.fontWeightMedium};
            letter-spacing: 0;
            line-height: 1.1875rem;
            text-align: center;
            padding: 0.625rem 0;
            display: inline-block;
            background: none !important;
            border: none !important;
            cursor: pointer;
            vertical-align: middle;
            span {
                font-size: ${themeFontSizes.size14};
                font-weight: ${themeFontWeights.fontWeightMedium};
            }
            &.current {
                color: ${themeColors.colorWhite} !important;
                background-color: ${themeColors.colorHeadText} !important;

                svg {
                    color: ${themeColors.colorWhite} !important;
                }
            }

            @media (max-width: 767px) {
                height: auto;
                text-align: left;
                padding-left: .9375rem;
                position: relative;

                .text {
                    max-width: 6.875rem;
                    display: inline-block;
                    vertical-align: bottom;
                    text-align: left;
                }

                .arrows {
                    display: inline-block;
                    vertical-align: bottom;
                    line-height: 1rem;
                    height: 1.125rem;
                    position: absolute;
                    right: .9375rem;
                    bottom: 0.625rem;
                }

                .up-arrow {
                    display: none;
                }

                &.current {
                    .down-arrow {
                        display: none;
                    }

                    .up-arrow {
                        display: inline-block;
                    }
                }
            }
        `,
    },
    buttonWrapper: {
        css: css`
            width: 100%;
            flex-basis: 100%;
            max-width: 100%;
            border: 0.0625rem solid ${themeColors.colorBorderCyanBlue};
            border-radius: 0.125rem;
            background-color: ${themeColors.colorBorderCyanBlueNew};
            margin-bottom: 1.25rem;
            padding: .250625rem 0.4375rem;
        `,
    },
    selectCard: {
        css: css`
            width: 100%;
            flex-basis: 100%;
            max-width: 100%;
            position: relative;

            @media screen and (max-width: 990px) {
                width: 100%;
                flex-basis: 100%;
                max-width: 100%;
            }

            .card-heading {
                color: ${themeColors.colorHeadText};
                font-family: 'Roboto', sans-serif;
                font-size: ${themeFontSizes.size18};
                font-weight: ${themeFontWeights.fontWeightMedium};
                letter-spacing: 0;
                line-height: 1.4375rem;
                margin-bottom: .9375rem;
                margin-top: 0.3125rem;
            }
        `,
    },
    titleContainer: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            align-content: center;

            .select-card {
                color: ${themeColors.colorMidGrey};
                font-family: 'Roboto', sans-serif;
                font-size: ${themeFontSizes.size15};
                letter-spacing: 0;
                line-height: 1.3125rem;
                display: inline-block;
                vertical-align: middle;
                margin-right: .9375rem;

                @media screen and (max-width: 480px) {
                    max-width: 5.375rem;
                }
            }

            span {
                vertical-align: middle;
            }

            svg {
                width: 1.5rem;
                height: 1.5rem;
                scale: 0.8;
            }
        `,
    },
};